import React, { useState, useEffect } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import LoadingPage from '../../components/LoadingPage'
import { db, firestore } from '../../../config/Fire'
import * as Constants from '../../../constants'
import moment from 'moment'
import { getInventory, getUser } from '../../../reducers'
import { Divider, DatePicker, Button } from 'antd'
import { loadInventory } from '../../../actions/inventory'
import XLSX from 'xlsx'
import './styles.css'

const { RangePicker } = DatePicker

const InventoryHistorical = props => {
    const [inventoryReservations, setInventoryReservations] = useState(null)
    const [inventoryReservationsLoading, setInventoryReservationsLoading] = useState(false)
    const [dates, setDates] = useState([])
    const [value, setValue] = useState()

    const onLoadInventory = () => {
        props.loadInventory()
        return <LoadingPage/>
    }

    const getInventoryReservations = async user => {
        setInventoryReservationsLoading(true)
        const startDateLong = moment(dates[0].format('DD/MM/YYYY') + ' -0300', 'DD/MM/YYYY -Z').startOf('day').toDate().getTime()
        const endDateLong = moment(dates[1].format('DD/MM/YYYY') + ' -0300', 'DD/MM/YYYY -Z').endOf('day').toDate().getTime()
        try {
            // const usersSnap = await db.ref(`${Constants.MAIN_NODES.USERS}`).once('value')
            // if (usersSnap.exists()) {
            //     const users = {}
            //     usersSnap.forEach(userSnap => {
            //         const user = userSnap.val()
            //         users[user.id] = user
            //     })
            // }
            const reservationsDocs = await firestore.collection(`${Constants.MAIN_NODES.INVENTORY_RESERVATIONS}`).where('endReserveDateLong', '>=', startDateLong).get()
            const reservations = {}
            reservationsDocs.forEach(doc => {
                const reserve = doc.data()
                if ((startDateLong >= reserve.startReserveDateLong && endDateLong <= reserve.endReserveDateLong) ||
                    (startDateLong <= reserve.startReserveDateLong && endDateLong >= reserve.endReserveDateLong) ||
                    (startDateLong <= reserve.startReserveDateLong && endDateLong >= reserve.startReserveDateLong) ||
                    (startDateLong <= reserve.endReserveDateLong && endDateLong >= reserve.endReserveDateLong)) {
                    reservations[reserve.id] = reserve
                }
            })
            const data = []
            const reservationsSorted = Object.values(reservations)
            reservationsSorted.sort(sortByDate)
            reservationsSorted.forEach(reserve => {
                let inventoryElementName = ''
                if (props.inventory[reserve.inventoryElementId]?.type === Constants.INVENTORY_TYPES.VEHICLE) {
                    inventoryElementName = `${props.inventory[reserve.inventoryElementId]?.name} (${props.inventory[reserve.inventoryElementId]?.plate})`
                } else {
                    inventoryElementName = `${props.inventory[reserve.inventoryElementId]?.name}`
                }
                if (props.inventory[reserve.inventoryElementId]?.type === Constants.INVENTORY_TYPES.VEHICLE) {
                    const row = [
                        inventoryElementName,
                        reserve.employeeName,
                        reserve.startReserveDate,
                        reserve.endReserveDate,
                        (reserve.kilometresEnd && reserve.kilometresStart) ? parseFloat(reserve.kilometresEnd) - parseFloat(reserve.kilometresStart) : '',
                        reserve.kilometresStart,
                        reserve.kilometresEnd,
                        reserve.fuelNaftaQuantityStart ? reserve.fuelNaftaQuantityStart == 'FULL' ? 'Lleno' : reserve.fuelNaftaQuantityStart == 'NOT_FULL' ? 'No lleno' : '' : reserve.fuelQuantityStart,
                        reserve.fuelGasoilQuantityStart == 'FULL' ? 'Lleno' : reserve.fuelGasoilQuantityStart == 'NOT_FULL' ? 'No lleno' : '',
                        reserve.fuelGasQuantityStart == 'FULL' ? 'Lleno' : reserve.fuelGasQuantityStart == 'NOT_FULL' ? 'No lleno' : '',
                        reserve.fuelNaftaQuantityEnd ? reserve.fuelNaftaQuantityEnd == 'FULL' ? 'Lleno' : reserve.fuelNaftaQuantityEnd == 'NOT_FULL' ? 'No lleno' : '' : reserve.fuelQuantityEnd,
                        reserve.loadedFuelNafta,
                        reserve.fuelGasoilQuantityEnd == 'FULL' ? 'Lleno' : reserve.fuelGasoilQuantityEnd == 'NOT_FULL' ? 'No lleno' : '',
                        reserve.loadedFuelGasoil,
                        reserve.fuelGasQuantityEnd == 'FULL' ? 'Lleno' : reserve.fuelGasQuantityEnd == 'NOT_FULL' ? 'No lleno' : '',
                        reserve.loadedFuelGas,
                        parseReserveStatus(reserve),
                        reserve.takenOutApprovedDateLong ? moment(reserve.takenOutApprovedDateLong).format('DD/MM/YYYY HH:mm') : '',
                        reserve.returnedApprovedDateLong ? moment(reserve.returnedApprovedDateLong).format('DD/MM/YYYY HH:mm') : '',
                        reserve.delegatedApprovedDateLong ? moment(reserve.delegatedApprovedDateLong).format('DD/MM/YYYY HH:mm') : '',
                        reserve.status !== Constants.INVENTORY_RESERVE_STATUS.ACCEPTED ? (reserve.delegateEmployeeName && reserve.delegateEmployeeName !== '') ? reserve.delegateEmployeeName : 'Depósito' : '',
                        [Constants.INVENTORY_RESERVE_STATUS.DELEGATED, Constants.INVENTORY_RESERVE_STATUS.RETURNED].includes(reserve.status) ? reserve.status === Constants.INVENTORY_RESERVE_STATUS.DELEGATED ? reserve.delegatedEmployeeName : 'Depósito' : '',
                        reserve.observations,
                        reserve.observationsTakenOut,
                        reserve.observationsReturned ?? reserve.observationsDelegated
                    ]
                    data.push(row)
                }
            })
            setDates(null)
            exportToXlsx(data)
        } catch (e) {
            console.log(e)
        }
        setInventoryReservationsLoading(false)
    }

    const sortByDate = (a, b) => {
        if (a.startReserveDateLong >= b.startReserveDateLong) {
            return 1
        } else {
            return -1
        }
    }

    const parseReserveStatus = (reserve) => {
        switch (reserve.status) {
            case Constants.INVENTORY_RESERVE_STATUS.ACCEPTED:
                return 'Aceptada';
            case Constants.INVENTORY_RESERVE_STATUS.TAKEN_OUT:
                return 'Retirada';
            case Constants.INVENTORY_RESERVE_STATUS.DELEGATED:
                return 'Delegada';
            case Constants.INVENTORY_RESERVE_STATUS.RETURNED:
                return 'Devuelta';
            default:
                return '';
        }
    }

    const exportToXlsx = (data) => {
        const columns = [[
            'Vehículo', 'Empleado', 'Fecha inicio', 'Fecha fin', 'Distancia', 'Kilómetros Inicio', 'Kilómetros Fin', 'Nafta Inicio', 'Gasoil Inicio', 'Gas Inicio', 
            'Nafta Fin', 'Litros Nafta cargados', 'Gasoil Fin', 'Litros Gasoil cargados', 'Gas Fin', 'M3 Gas cargados',
            'Estado Reserva', 'Fecha - Retirado', 'Fecha - Devuelto', 'Fecha - Delegado', 'Tomado de', 'Entregado a', 'Observaciones', 'Observaciones Inicio', 'Observaciones Fin'
        ]].concat(data)
        const dataxlsx = columns.map(it => {
            return Object.values(it)
        })
        const binaryWS = XLSX.utils.json_to_sheet(dataxlsx, { skipHeader: true })
        binaryWS['!cols'] = fitToColumn(columns)
        // Create a new Workbook
        var wb = XLSX.utils.book_new()

        let fileName = 'inv'
        if (dates && dates.length === 2) {
            fileName = `inv_${dates[0].format('DD-MM-YYYY')}_${dates[1].format('DD-MM-YYYY')}`
        }

        // Name your sheet
        XLSX.utils.book_append_sheet(wb, binaryWS, fileName)

        // export your excel

        XLSX.writeFile(wb, `${fileName}.xlsx`)
    }

    const fitToColumn = (arrayOfArray) => {
        // get maximum character of each column
        return arrayOfArray[0].map((a, i) => ({ wch: Math.max(...arrayOfArray.map(a2 => {
            return a2[i] ? a2[i].toString().length : 0
            })) }));
    }

    return (
        <div className="inventoryHistoricalCont">
            {
                props.user ?
                    props.inventory ?
                        <Grid>
                            <Divider>Inventario - Historial</Divider>
                            <Row center="xs">
                                <Col xs={12}>
                                    <h4>Seleccione un rango de fechas para exportar</h4>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12}>
                                    <RangePicker
                                        disabled={inventoryReservationsLoading}
                                        onCalendarChange={val => setDates(val)}
                                        onChange={val => setValue(val)}
                                        value={dates && dates.length === 2 ? [dates[0], dates[1]] : []}
                                        format={'DD/MM/YYYY'}
                                    />
                                    <Button
                                        loading={inventoryReservationsLoading}
                                        style={{ margin: '0 0 0 8px' }}
                                        disabled={!(dates && dates.length === 2 && dates[0] !== null && dates[1] !== null)}
                                        onClick={getInventoryReservations}>Exportar</Button>
                                </Col>
                            </Row>
                        </Grid>
                        :
                        onLoadInventory()
                    :
                    <LoadingPage/>
            }
        </div>
    )
}

InventoryHistorical.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({
    loadInventory: value => dispatch(loadInventory(value))
})

const mapStateToProps = state => ({
    user: getUser(state),
    inventory: getInventory(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(InventoryHistorical))
